import React, { useEffect } from 'react';

export default function addTitle<P extends object>(WrappedComponent: React.FunctionComponent<P>, title: string) {
  return function ComponentDecoratedWithTitle(props: P) {
    useEffect(() => {
      document.title = title;

      return () => {
        document.title = '';
      };
    }, []);

    return <WrappedComponent {...props} />;
  };
}
